import axios from 'axios';
import Common from './Common';
export default {
    getRecuitmentBonus(user_id) {
        return axios.get(Common.api + 'get-recruiting-bonus/' + user_id);
    },
    getDashboardBonus(user_id) {
        return axios.get(Common.api + 'get-dashboard-bonus/' + user_id);
    },
    getDashboardDirectBonus(user_id) {
        return axios.get(Common.api + 'my-commission-total/' + user_id);
    },
    getRankingBonus(user_id) {
        return axios.get(Common.api + 'get-ranking-bonus/' + user_id);
    },
    getLotteryBonus(user_id) {
        return axios.get(Common.api + 'get-lottery-bonus/' + user_id);
    },
    getEligibilityStat(user_id) {
        return axios.get(Common.api + 'get-eligibility-stat/' + user_id);
    },
    newChildList(user_id) {
        return axios.get(Common.api + 'new-children-list/' + user_id);
    },
    activeChildList(user_id) {
        return axios.get(Common.api + 'new-active-children-list/' + user_id);
    },
    getAffiliatorTree(id) {
        return axios.get(Common.api + 'get-tree/' + id);
    },
    getAffiliator(id) {
        return axios.get(Common.api + 'get-aff-id/' + id);
    },
    getAffiliatedProducts(data) {
        return axios.post(Common.api + 'aff-list-for-queue', data);
    },
    getAffiliatorInfo(id, i) {
        return axios.get(Common.api + 'cookie-history/' + id + '/' + i);
    },
    saveAffiliatedProducts(data) {
        return axios.post(Common.api + 'add-my-queue', data)
    },
    sendAffiliatorInfo(data) {
        return axios.post(Common.api + 'cookie-alternate', data);
    },
    sendAffiliatorLink(data) {
        return axios.post(Common.api + 'valid-link', data);
    },
    sendAffiliatorHomeLink(data) {
        return axios.post(Common.api + 'universal-link', data);
    },
    sendAffiliatorSearch(data) {
        return axios.post(Common.api + 'get-particular-child', data);
    },
    sendAffliatorProductSearch(data) {
        return axios.post(Common.api + 'get-aff-sales', data);
    },
    getFilteredBonus(data) {
        return axios.post(Common.api + 'get-aff-bonus-filtered-ranking', data);
    },
    getFilteredBonusRec(data) {
        return axios.post(Common.api + 'get-aff-bonus-filtered-recruit', data);
    }
}